<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" :before-close="hide">
      <el-form ref="form" :model="queryParams" :rules="rules" label-position="left">
        <el-row :gutter="20">
          <BjSelectChannelStore :span="12" :query-params="queryParams" :query-props="['channel', 'storeCode']" @handleChannelChange="handleChannelChange" @handleStoreChange="handleStoreChange"/>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('DetailsOfThirdPartyAfterSalesOrder.time')" prop="queryParamsTime">
              <el-date-picker v-model="queryParams.queryParamsTime" class="full-width" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" :picker-options="$pickerOptions()" align="right" :start-placeholder="$t('form.startDateText')" :end-placeholder="$t('form.endDateText')" :default-time="['00:00:00', '23:59:59']" />
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer mt20">
        <el-button @click="resetForm">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
    <StoreDialog ref="storeDialog" @confirm="dialogListConfirm" />
  </div>
</template>
<script>
import StoreDialog from './storeDialog.vue';
import { afterApi } from '@/api';

export default {
  components: { StoreDialog },
  props: {
    maxLength: {
      type: Number,
      default: 100,
    },
  },
  data() {
      return {
        platformType: [
          {label: 'CA', value: 'CA'},
          {label: 'SPF', value: 'SPF'},
          {label: 'FBM', value: 'FBM'},
        ],
      dialogVisible: false,
      queryParams: {
            queryParamsTime: [],
            channel: null,
            storeCode: null,
            beginTime: null,
            endTime: null
        },
      rules: {
        channel: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        queryParamsTime: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        storeCode: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
      },
      title: '',
      storeData: [],
      storeChannel: null,
      storeCode: null
    };
  },
  created() {},
  methods: {
    show(title = this.$t('ExternalOrders.download.order')) {
      this.title = title;
      this.dialogVisible = true;
    },
    resetForm() {
      this.$refs['form'].resetFields();
      this.hide();
    },
    hide() {
      this.dialogVisible = false;
    },
    handleChannelChange(val, item){
      this.storeChannel = item.label;
    },
    handleStoreChange(val, item){
      this.storeCode = item.code
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = {
            channel: this.storeChannel,
            storeCode: this.storeCode,
            beginTime: this.queryParams.queryParamsTime[0],
            endTime: this.queryParams.queryParamsTime[1],
          };
          afterApi.csgOrderSync(data).then(res => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.resetForm();
              this.$emit('refresh')
            }
          });
        } else {
          return false;
        }
      });
    },
    disabledDate(time) {
      // 限制时间选择一年内
      const nowDate = new Date().toString(); // 获取时间转字符串
      const nowDateYear = new Date().getFullYear(); // 当前时间的年份
      // 字符串年份替换为一年前
      const oneYearAgoDate = nowDate.replace(nowDateYear, nowDateYear - 1);
      // 一年前字符串转为时间戳
      const oneYear = new Date(oneYearAgoDate).getTime();
      return time.getTime() > Date.now() || time.getTime() < oneYear;
    },
    open() {
      this.$refs.storeDialog.show(this.storeData);
    },
    // 添加店铺回调
    dialogListConfirm(data) {
      this.storeData = data;
      const RES = data[0];
      // 判断是否存在三方店铺ID
      // if (!RES.mallId) {
      // } else {
      // 获取三方店铺id
      this.form.mallId = RES.mallId;
      this.form.storeCode = RES.code;
      this.form.storeId = RES.id;
      this.form.storeName = RES.name;
      this.form.channelTypeMeaning = RES.channelTypeMeaning;
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-radio {
  height: 30px;
}
</style>
